module.exports = __webpack_public_path__ + "static/media/option-2.be876397.ogg";